/* eslint-disable react-hooks/exhaustive-deps */

import React, { ReactElement } from 'react'
import { TrainingGroup } from '../../../types/training'
import AdminPartText from '../../../components/Admin/part/add-edit-part/text'
import AdminPartQuiz from '../../../components/Admin/part/add-edit-part/quiz/preview-quiz'

interface AdminpartProps {
  trainingsGroup: TrainingGroup
  categoryId: string
  partId: string
}

const AdminPart = ({
  trainingsGroup,
  categoryId,
  partId,
}: AdminpartProps): ReactElement => {
  const training = trainingsGroup.trainings[0]
  const category = training?.categories.find((c) => c.id === categoryId)
  const part = category?.parts.find((p) => p.id === partId)

  return (
    <>
      {part?.isWhat === 'info' ? (
        <AdminPartText
          training={training}
          category={category}
          part={part}
          trainingsGroup={trainingsGroup}
        />
      ) : (
        <AdminPartQuiz
          training={training}
          category={category}
          part={part}
          trainingsGroup={trainingsGroup}
        />
      )}
    </>
  )
}
export default AdminPart
